<form class="d-flex flex-column gap-4" [formGroup]="formGroup">
  <div class="form-container">
    <div class="d-flex flex-column gap-1">
      <label class="form-input-label" [for]="'email'" i18n>Email Address</label>
      <app-email-input
        [error]="formGroup?.controls?.email?.invalid && formSubmitted"
        formControlName="email"
        controlId="email" />
      <app-form-error
        *ngIf="formSubmitted && formGroup?.controls?.email?.invalid"
        [errors]="formGroup?.controls?.email?.errors" />
    </div>
    <div class="d-flex flex-column gap-1">
      <label class="form-input-label" [for]="'phoneNumber'" i18n>Phone Number</label>
      <app-phone-country-code
        controlId="phoneNumber"
        [countryCodes]="countryCodes$ | async"
        [formGroup]="formGroup"
        [error]="formGroup?.controls?.phoneNumber?.invalid && formSubmitted"
        [phoneNumberControlName]="'phoneNumber'"
        [countryCodeControlName]="'phoneNumberCountryCode'" />
      <app-form-error
        *ngIf="formSubmitted && formGroup?.controls?.phoneNumber?.invalid"
        [errors]="formGroup?.controls?.phoneNumber?.errors" />
    </div>
  </div>

  <hr class="m-0" />

  <div class="checkbox-container" *ngIf="originalMember && originalMember.address">
    <app-checkbox-input formControlName="useMemberAddress" controlId="useMemberAddress" />
    <app-form-option-label labelFor="useMemberAddress">{{ useAddressCheckboxLabel$ | async }}</app-form-option-label>
  </div>

  <app-international-address-form-grid
    controlIdPrefix="spouseAddress"
    [form]="formGroup.controls.address"
    [formSubmitted]="formSubmitted" />
</form>
